"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Soap = function Soap(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "soap",
    size: size
  }, _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M5 .75a1 1 0 01.47 1.88l-.55-.32a.75.75 0 00-.76-.01A1 1 0 015 .75z"
  }), _react["default"].createElement("path", {
    fill: color,
    d: "M3.97 1.94a1 1 0 011.1-.05l1.44.87c.3.18.49.51.49.86v.92a1 1 0 01-.42.81L4.03 7.17a1 1 0 01-1.1.05L1.5 6.35A1 1 0 011 5.49v-.92a1 1 0 01.42-.81zm.13.4L1.62 4.11a.5.5 0 00.03.84l1.29.77a1 1 0 001.1-.05L6.37 4a.5.5 0 00-.03-.84l-1.43-.85a.75.75 0 00-.82.03z"
  }), _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M2 2.5a.5.5 0 110 1 .5.5 0 010-1zm1-1.25a.5.5 0 110 1 .5.5 0 010-1zm-1.25 0a.25.25 0 110 .5.25.25 0 010-.5z"
  }));
};

Soap.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = Soap;
exports["default"] = _default;